import { Component, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Header } from "@/components/Header";
import { Marquee } from "@/components/Marquee";
import { HeroColumns } from "@/components/HeroColumns";
import { Included } from "@/components/Included";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { initLenis, destroyLenis } from "@/lib/lenis";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, fontFamily: "sans-serif" }}>
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function HomePage() {
  return (
    <>
      <Seo path="/" />
      <div className="hero">
        <Header />
        <Marquee />
        <HeroColumns />
      </div>
      <Included />
      <Footer />
    </>
  );
}

/* Route table shared by the browser entry (index.js) and the build-time prerender. */
export function AppRoutes() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<HomePage />} />
        {/* Every other path (incl. the retired inner pages) goes home. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ErrorBoundary>
  );
}

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    initLenis();
    return () => destroyLenis();
  }, []);

  return <AppRoutes />;
}

export default App;
